import React from 'react';
import moment from 'moment-timezone';
import * as DataList from 'components/DataList';

// Status pills for a job's records, in the same colours as their list screens
// (Tables/WorkReports, Quotes, Invoices, Timesheets), so a status reads the
// same everywhere.

const sentence = (value) => {
  const text = String(value || '').replace(/_/g, ' ').trim();
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
};

const WORK_ORDER_TONES = { draft: 'grey', submitted: 'blue', reviewed: 'purple', invoiced: 'green' };
const ESTIMATE_TONES = { draft: 'grey', submitted: 'blue', sent: 'blue', approved: 'green', on_hold: 'amber', rejected: 'red' };
const TIMELOG_TONES = { draft: 'grey', approved: 'green', rejected: 'red' };

export const WorkOrderPill = ({ attributes }) => (
  <DataList.Pill tone={WORK_ORDER_TONES[attributes.status] || 'grey'}>{sentence(attributes.status)}</DataList.Pill>
);

export const EstimatePill = ({ attributes }) => (
  <DataList.Pill tone={ESTIMATE_TONES[attributes.status] || 'grey'}>{sentence(attributes.status)}</DataList.Pill>
);

// Invoices by payment: paid green, part-paid amber, unpaid grey, and red once
// an unpaid invoice is past its due date.
export const InvoicePill = ({ attributes }) => {
  const payment = attributes.payment_status;
  if (!payment) {
    return <DataList.Pill tone="grey">{sentence(attributes.status)}</DataList.Pill>;
  }
  const overdue = payment !== 'paid' && attributes.invoice_due_date
    && moment(attributes.invoice_due_date).isBefore(moment(), 'day');
  let tone = 'grey';
  if (payment === 'paid') tone = 'green';
  else if (payment === 'partially_paid') tone = 'amber';
  if (overdue) tone = 'red';
  return (
    <DataList.Pill tone={tone}>
      {overdue ? 'Overdue' : (attributes.formatted_payment_status || sentence(payment))}
    </DataList.Pill>
  );
};

export const TimeLogPills = ({ attributes }) => (
  <React.Fragment>
    <DataList.Pill tone={TIMELOG_TONES[attributes.status] || 'grey'}>{sentence(attributes.status)}</DataList.Pill>
    {attributes.is_overtime && <DataList.Pill tone="amber">Overtime</DataList.Pill>}
  </React.Fragment>
);
